import { checkPagesId, checkConfig } from './utils';

export const getScreenIdsValidator = (config) => {
    return [
        { exec: checkPagesId, args: config, message: 'INVALID PAGE ID' },
        { exec: checkConfig, args: config, message: 'INVALID CONFIG' },
    ];
};
